<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">컨셉 추가하기</p>

    <v-sheet class="mt-2 px-4">
      <!-- 상품타입 -->
      <v-select :items="select_list.productType" class="rounded-10" label="상품타입" dense outlined v-model="create.productType"></v-select>

      <v-divider class="my-4"></v-divider>

      <!-- 이미지 편집/미리보기 -->
      <v-sheet outlined class="rounded-10 pa-2 mt-2">
        <clipper-basic :src="url" ref="clipper1" class="my-clipper" :ratio="4 / 2.5" :init-width="100">
          <div class="placeholder d-flex align-center justify-center" slot="placeholder">
            <span class="text-caption grey--text">이미지 미리보기</span>
          </div>
        </clipper-basic>
      </v-sheet>

      <!-- 이미지 첨부 -->
      <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile" @dragover.prevent>
        <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="이미지" v-model="uploadImage" @change="onFileChange()">
          <template v-slot:prepend-inner>
            <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
          </template>
        </v-file-input>
      </v-sheet>

      <!-- 기본 패턴 이미지 -->
      <v-sheet outlined class="rounded-10 pa-2 mt-2">
        <clipper-basic :src="url2" ref="clipper2" class="my-clipper" :ratio="2.5 / 3" :init-width="100">
          <div class="placeholder d-flex align-center justify-center" slot="placeholder">
            <span class="text-caption grey--text">기본 패턴 이미지 미리보기</span>
          </div>
        </clipper-basic>
      </v-sheet>

      <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile2" @dragover.prevent>
        <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="기본 패턴 이미지" v-model="uploadImage2" @change="onFileChange2()">
          <template v-slot:prepend-inner>
            <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
          </template>
        </v-file-input>
      </v-sheet>

      <!-- 추가 패턴 이미지 (동적) -->
      <v-divider class="my-4"></v-divider>
      <div class="d-flex align-center justify-space-between mb-2">
        <span class="font-weight-bold">추가 패턴 이미지</span>
        <v-btn small color="primary" depressed @click="addPatternImage">
          <v-icon small left>mdi-plus</v-icon>
          패턴 추가
        </v-btn>
      </div>

      <v-sheet v-for="(pattern, index) in patternOthersImages" :key="pattern.id" class="mb-4 pa-3" outlined>
        <div class="d-flex align-center justify-space-between mb-2">
          <span class="text-caption grey--text">패턴 {{ index + 1 }}</span>
          <v-btn x-small color="red" text @click="removePatternImage(index)">
            <v-icon small>mdi-delete</v-icon>
            삭제
          </v-btn>
        </div>

        <v-sheet outlined class="rounded-10 pa-2">
          <clipper-basic :src="pattern.url" :ref="`clipperOther${index}`" class="my-clipper" :ratio="2.5 / 3" :init-width="100">
            <div class="placeholder d-flex align-center justify-center" slot="placeholder">
              <span class="text-caption grey--text">추가 패턴 {{ index + 1 }} 미리보기</span>
            </div>
          </clipper-basic>
        </v-sheet>

        <v-sheet class="mt-2" @drop.prevent="(e) => addDropFileOther(e, index)" @dragover.prevent>
          <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" :label="`추가 패턴 ${index + 1} 이미지`" v-model="pattern.file" @change="onFileChangeOther(index)">
            <template v-slot:prepend-inner>
              <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
            </template>
          </v-file-input>
        </v-sheet>
      </v-sheet>

      <v-divider class="my-4"></v-divider>
      <v-text-field class="rounded-10" label="제목(한글)" dense outlined v-model="create.title"></v-text-field>
      <v-text-field class="rounded-10" label="제목(영어)" dense outlined v-model="create.title_en"></v-text-field>
      <v-text-field class="rounded-10" label="제목(일어)" dense outlined v-model="create.title_jp"></v-text-field>
      <v-autocomplete class="rounded-10" label="태그" dense outlined multiple :items="select_list.tag" v-model="create.tag"></v-autocomplete>
      <v-text-field class="rounded-10" label="새도우" dense outlined v-model="create.shadow_json"></v-text-field>
      <v-select :items="select_list.status" class="rounded-10" label="상태" dense outlined v-model="create.status"></v-select>
      <v-text-field class="rounded-10" label="순서" dense outlined type="number" v-model="create.order"></v-text-field>

      <!-- 본문 -->
      <v-divider></v-divider>
      <v-sheet>
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
          <v-btn color="primary" depressed outlined small @click="clear('ko')">삭제</v-btn>
        </div>

        <TipTapWriter class="tiptap_style" :options="options" :key="'ko' + componentKey" />
      </v-sheet>

      <v-sheet class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
          <v-btn color="primary" depressed outlined small @click="clear('en')">삭제</v-btn>
        </div>
        <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en' + en.componentKey" />
      </v-sheet>

      <v-sheet class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">일어</div>
          <v-btn color="primary" depressed outlined small @click="clear('jp')">삭제</v-btn>
        </div>
        <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp' + jp.componentKey" />
      </v-sheet>
    </v-sheet>
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="createSubmit()">
        <v-icon small left>mdi-database-edit-outline</v-icon>
        추가하기
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import TipTapReader from "@/components/tiptap/Reader"
import { AllTag, Tags } from "@/constant"

export default {
  components: {
    TipTapWriter,
    TipTapReader,
  },
  props: {
    src: {
      type: Object | undefined | null,
    },
  },

  data: () => ({
    select_list: {
      tag: Tags.map((e) => e.title),
      status: ["노출", "숨김"],
      productType: [
        { text: "메이커샷", value: "makershot" },
        { text: "프리미엄", value: "premium" },
      ],
    },

    uploadImage: {},
    url: "",

    uploadImage2: {},
    url2: "",

    patternOthersImages: [],

    create: {
      thumbnail_image: "",
      pattern_1_image: "",
      productType: "makershot",
      title: "",
      title_en: "",
      title_jp: "",
      price: "",
      tag: "",
      status: "노출",
      shutter_speed: "",
      aperture: "",
      iso: "",
      camera: "",
      light_left: "",
      light_right: "",
      studio_type: "",
      pose_type: "",
      standing_type: "",
      shadow_json: "{'json':2}",
      order: 1,
    },

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
  }),

  mounted() {
    if (this.src.tag) {
      this.create.tag = this.src.tag.split(",")
    }
    this.create.shadow_json = this.src.shadow_json
    if (this.src.content) {
      this.options.content = this.src.content
    }
    this.componentKey++
    this.en.options.content = this.src.content_en
    this.en.componentKey++
    this.jp.options.content = this.src.content_jp
    this.jp.componentKey++
  },

  methods: {
    // 파일 드래그앤드롭
    addDropFile(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage = e.dataTransfer.files[0]
      this.url = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange() {
      const file = this.uploadImage
      this.url = URL.createObjectURL(file)
    },

    // 파일 드래그앤드롭
    addDropFile2(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage2 = e.dataTransfer.files[0]
      this.url2 = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange2() {
      const file = this.uploadImage2
      this.url2 = URL.createObjectURL(file)
    },

    // 추가 패턴 이미지 추가
    addPatternImage() {
      this.patternOthersImages.push({
        id: `pattern_other_${this.patternOthersImages.length + 1}`,
        file: null,
        url: "",
        order: this.patternOthersImages.length + 1,
      })
    },

    // 추가 패턴 이미지 제거
    removePatternImage(index) {
      this.patternOthersImages.splice(index, 1)
      // order 재정렬
      this.patternOthersImages.forEach((pattern, idx) => {
        pattern.order = idx + 1
        pattern.id = `pattern_other_${idx + 1}`
      })
    },

    // 추가 패턴 드래그앤드롭
    addDropFileOther(e, index) {
      const file = e.dataTransfer.files[0]
      this.patternOthersImages[index].file = file
      this.patternOthersImages[index].url = URL.createObjectURL(file)
    },

    // 추가 패턴 파일 선택시 이미지 표시
    onFileChangeOther(index) {
      const file = this.patternOthersImages[index].file
      if (file) {
        this.patternOthersImages[index].url = URL.createObjectURL(file)
      }
    },

    // 이미지 업로드 (DB 입력)
    imageUpload: _.debounce(async function () {
      // 썸네일 이미지 업로드
      const canvas = this.$refs.clipper1.clip()
      var imgDataUrl = canvas.toDataURL("image/webp", 0.5)
      var binaryData = atob(imgDataUrl.split(",")[1])
      var array = []
      for (var i = 0; i < binaryData.length; i++) {
        array.push(binaryData.charCodeAt(i))
      }
      var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
      var formData = new FormData()
      formData.append("image", file)

      await this.$http
        .post("/api/image/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "concept/thumbnail_image",
          },
        })
        .then((res) => {
          this.create.thumbnail_image = res.data
        })

      // 기본 패턴 이미지 업로드
      const canvas2 = this.$refs.clipper2.clip()
      var imgDataUrl2 = canvas2.toDataURL("image/webp", 0.5)
      var binaryData2 = atob(imgDataUrl2.split(",")[1])
      var array2 = []
      for (var i = 0; i < binaryData2.length; i++) {
        array2.push(binaryData2.charCodeAt(i))
      }
      var file2 = new File([new Uint8Array(array2)], "filename.png", { type: "image/png" })
      var formData2 = new FormData()
      formData2.append("image", file2)

      await this.$http
        .post("/api/image/upload", formData2, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "concept/thumbnail_image",
          },
        })
        .then((res) => {
          this.create.pattern_1_image = res.data
        })

      // 추가 패턴 이미지 업로드
      const patternOthersData = []
      for (let index = 0; index < this.patternOthersImages.length; index++) {
        const pattern = this.patternOthersImages[index]
        if (pattern.file) {
          const clipperRef = this.$refs[`clipperOther${index}`]
          if (clipperRef && clipperRef[0]) {
            const canvas = clipperRef[0].clip()
            var imgDataUrl = canvas.toDataURL("image/webp", 0.5)
            var binaryData = atob(imgDataUrl.split(",")[1])
            var array = []
            for (var i = 0; i < binaryData.length; i++) {
              array.push(binaryData.charCodeAt(i))
            }
            var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
            var formData = new FormData()
            formData.append("image", file)

            await this.$http
              .post("/api/image/upload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                params: {
                  type: "concept/thumbnail_image",
                },
              })
              .then((res) => {
                patternOthersData.push({
                  id: pattern.id,
                  image: res.data,
                  order: pattern.order,
                })
              })
          }
        }
      }

      console.log(this.create)

      // DB 입력
      await this.$http
        .post("/api/concept/insert", {
          params: {
            thumbnail_image: this.create.thumbnail_image,
            pattern_1_image: this.create.pattern_1_image,
            pattern_others_image: patternOthersData,
            productType: this.create.productType,
            title: this.create.title,
            title_en: this.create.title_en,
            title_jp: this.create.title_jp,
            content: this.options.content,
            content_en: this.en.options.content,
            content_jp: this.jp.options.content,
            tag: this.create.tag.toString(),
            status: this.create.status,
            shadow_json: this.create.shadow_json,
            order: Number(this.create.order),
          },
        })
        .then((res) => {
          if (res.data.affectedRows) {
            alert("컨셉이 정상적으로 등록되었습니다")
            this.$emit("close")
          }
        })
    }, 500),

    // 목록
    async createSubmit() {
      // 업로드 이미지 검증
      if (!this.uploadImage || !(this.uploadImage instanceof File)) {
        alert("썸네일 이미지를 첨부해주세요")
        return
      }

      // 기본 패턴 이미지 검증
      if (!this.uploadImage2 || !(this.uploadImage2 instanceof File)) {
        alert("기본 패턴 이미지를 첨부해주세요")
        return
      }

      // 상품타입 검증
      if (!this.create.productType) {
        alert("상품타입을 선택해주세요")
        return
      }

      // 제목 검증
      if (this.create.title == "") {
        alert("제목을 입력해주세요")
        return
      }

      // 컨셉소개 내용 검증
      if (this.options.content == "") {
        alert("컨셉소개 내용을 입력해주세요")
        return
      }

      // 태그 검증
      if (this.create.tag.toString() == "") {
        alert("태그를 입력해주세요")
        return
      }

      // shadow
      else if (this.create.shadow_json == "") {
        alert("새도우값을 입력해주세요")
        return
      }

      // 이미지 업로드 (DB 입력)
      await this.imageUpload()
    },

    clear(lang = "ko") {
      if (lang === "ko") {
        this.options.content = ""
        this.componentKey++
      } else if (lang === "en") {
        this.en.options.content = ""
        this.en.componentKey++
      } else if (lang === "jp") {
        this.jp.options.content = ""
        this.jp.componentKey++
      }
    },
  },
}
</script>
<style scoped>
.my-clipper {
  width: 100%;
}

.placeholder {
  width: 100%;
  height: 150px;
}
</style>
